import axios, { AxiosInstance, AxiosResponse } from "axios";
import { checkActions } from "../utils";
import { ResType } from "../types/checkAuth";

const BASE_URL = import.meta.env.VITE_API_URL;
const COUNTRY_URL = "https://restcountries.com/v3.1";
const WS_URL = BASE_URL.replace(/^https?/, "wss").replace(/\/api$/, "/ws");

const activityLogger: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 120000,
  withCredentials: true,
});
const uploadInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});
const countryAPI: AxiosInstance = axios.create({
  baseURL: COUNTRY_URL,
  timeout: 80000,
  withCredentials: true,
});

const axiosInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 120000,
  withCredentials: true,
});
uploadInstance.interceptors.response.use(
  async function (response: AxiosResponse) {
    const method = response.config.method?.toUpperCase();
    const url = response.config.url;

    if (
      method &&
      method !== "GET" &&
      url &&
      !url.includes("activityLogs") &&
      !url.includes("/mfa/") &&
      !url.includes("user/login")
    ) {
      try {
        const userId = url.includes("login")
          ? response.data.id
          : localStorage.getItem("userId");
        const text = checkActions(method as ResType, url);
        if (text !== undefined) {
          return await activityLogger.post("activityLogs", { userId, text });
        }
      } catch (error) {
        console.error("Error logging activity:", error);
      }
    }

    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  async function (response: AxiosResponse) {
    const method = response.config.method?.toUpperCase();
    const url = response.config.url;

    if (
      method &&
      method !== "GET" &&
      url &&
      !url.includes("activityLogs") &&
      !url.includes("/mfa/") &&
      !url.includes("user/login")
    ) {
      try {
        const userId = url.includes("login")
          ? response.data.id
          : localStorage.getItem("userId");

        const text = checkActions(method as ResType, url);
        if (text !== undefined) {
          await activityLogger.post("activityLogs", { userId, text });
        }
      } catch (error) {
        console.error("Error logging activity:", error);
      }
    }

    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export {
  activityLogger,
  axiosInstance,
  countryAPI,
  uploadInstance,
  BASE_URL,
  WS_URL,
};
